// apps/admin/src/data/marketingStrategyData.js
// Master Marketing Strategy, Multilingual Video Ad Scripts, Linking Map & ₹10,000/Month Plan
// Extracted and structured from docs/marketing_strategy.md for dynamic rendering in Super Admin

export const MARKET_STRATEGY_DATA = {
  overview: {
    tam: "15,000,000+",
    tamDescription: "Home-based micro-businesses and social sellers operating across Instagram, WhatsApp & Facebook in India.",
    keyHubs: [
      { name: "Tamil Nadu", cities: "Chennai, Coimbatore, Madurai, Salem, Tirupur, Erode", focus: "Aari Blouses, Designer Sarees, Pattu Pavadai" },
      { name: "Karnataka", cities: "Bangalore Urban, Mysore, Mangalore, Hubli-Dharwad", focus: "Handicrafts, Decor, Footwear & Boutiques" },
      { name: "AP & Telangana", cities: "Hyderabad, Visakhapatnam, Vijayawada, Guntur, Warangal", focus: "Maggam Work, Handloom Sarees, Jewelry" },
      { name: "Kerala", cities: "Kochi, Calicut, Trivandrum, Thrissur, Kannur", focus: "Kasavu Sarees, Churidars, Custom Apparel" },
      { name: "North & Central India", cities: "Delhi NCR, Jaipur, Surat, Indore, Lucknow, Mumbai", focus: "Suits, Kurtis, Custom Phone Cases, Decor" }
    ],
    positioning: "Ownezzy is the 60-Second E-Commerce Engine for Social Sellers.",
    usp: "Turn your Instagram DM mess into an automated online store in 60 seconds · 7-Day 100% Free Trial · No Credit Card Required · 0% Sales Commission",
    pillars: [
      {
        title: "Pre-Built Niche Catalog",
        tagline: "No Blank Canvas",
        desc: "When a boutique seller joins, they don't see an empty site; they see royal crimson boutique banners, blouse neckline selectors, and ready sample products."
      },
      {
        title: "Direct UPI & WhatsApp Integration",
        tagline: "Instant Payouts",
        desc: "Customers pay directly via PhonePe, Google Pay, or Paytm straight to the seller's bank account with instant automated WhatsApp confirmations."
      },
      {
        title: "0% Sales Commission",
        tagline: "Keep 100% Profits",
        desc: "Unlike marketplaces taking 15%–30% cuts, the seller keeps 100% of their earnings with zero transaction deduction on UPI."
      },
      {
        title: "Frictionless 7-Day Free Trial",
        tagline: "Zero Risk",
        desc: "No credit card required. Anyone can test their live store and dashboard for two full weeks with zero financial commitment."
      }
    ],
    psychologicalTriggers: [
      {
        nightmare: "Typing 'Price please? / Check DM' 100+ times a day while managing family or shop.",
        reality: "Send one link. Customer picks size, pays on UPI, and enters address in 30 seconds."
      },
      {
        nightmare: "Buyers ghosting when asked to share manual UPI payment screenshots.",
        reality: "Professional automated checkout builds instant trust; buyers pay via PhonePe/GPay without friction."
      },
      {
        nightmare: "Orders jotted down on rough paper notebooks or lost in pinned WhatsApp chats.",
        reality: "Clean digital dashboard with live order tracking (Placed, Dispatched, Delivered) and telephone alarm."
      },
      {
        nightmare: "Feeling like an amateur DM reseller struggling to look established.",
        reality: "Owning a branded store (mybrand.ownezzy.com or custom domain) brings instant credibility."
      }
    ]
  },

  // THE 20 READY-TO-USE SPECIALIZED DEMO STORES
  demoStores20: [
    { id: "clothing", name: "UrbanThread", label: "Clothing & Boutique", icon: "👗", demo: "fashion", ctr: 0.034, focus: "Kurtis, sarees, salwar suits, lehengas & co-ords with sizes and colours." },
    { id: "plants", name: "GreenNest", label: "Plants & Gardening", icon: "🌱", demo: "plants", ctr: 0.028, focus: "Indoor plants, ceramic pots, seeds & organic fertilizers." },
    { id: "gifts", name: "Giftly", label: "Gift Store & Hampers", icon: "🎁", demo: "gifts", ctr: 0.032, focus: "Personalized gift hampers, flowers, chocolates & anniversary boxes." },
    { id: "pets", name: "PawPantry", label: "Pet Store & Accessories", icon: "🐾", demo: "pet", ctr: 0.030, focus: "Pet food, chew toys, grooming shampoos & everyday essentials." },
    { id: "aquarium", name: "AquaLeaf", label: "Aquarium & Aquatic Plants", icon: "🐠", demo: "aqualeaf", ctr: 0.027, focus: "Live fish, aquatic plants, tanks, LED lights & fish food." },
    { id: "wellness", name: "Lather & Bloom", label: "Soaps & Perfumes", icon: "🧼", demo: "soaps", ctr: 0.031, focus: "Handmade cold-pressed soaps, perfumes & skincare gift sets." },
    { id: "footwear", name: "SoleChic", label: "Footwear & Juttis", icon: "👡", demo: "footwear", ctr: 0.036, focus: "Handcrafted Punjabi juttis, bridal mojaris & cushioned festive slides." },
    { id: "uruli", name: "Paramparya", label: "Brassware & Bronze Urulis", icon: "🪔", demo: "uruli", ctr: 0.033, focus: "Kumbakonam bronze urulis, Nachiarkoil Kuthu Vilakkus & pooja decor." },
    { id: "grocery", name: "DailyBasket", label: "Grocery & Daily Essentials", icon: "🛒", demo: "grocery", ctr: 0.026, focus: "Pantry essentials, regional spices, cold-pressed oils & snacks." },
    { id: "fresh", name: "FarmFresh", label: "Fruits & Vegetables", icon: "🥬", demo: "fresh", ctr: 0.025, focus: "Farm-fresh fruits, organic greens, seasonal baskets & dry fruits." },
    { id: "tech", name: "CaseVault", label: "Phone Cases & Tech", icon: "📱", demo: "cases", ctr: 0.042, focus: "10ft drop-tested phone cases, MagSafe accessories & device skins." },
    { id: "bags", name: "ToteVibe", label: "Bags & Totes", icon: "👜", demo: "bags", ctr: 0.035, focus: "Organic cotton canvas totes, padded laptop sleeves & everyday slings." },
    { id: "crafts", name: "CraftedCanvas", label: "Custom Crafts & Art", icon: "🧵", demo: "crafts", ctr: 0.037, focus: "Personalized resin keepsakes, wood nameplates & clay charms." },
    { id: "decor", name: "LuminaNest", label: "Home Decor & Candles", icon: "🕯️", demo: "decor", ctr: 0.032, focus: "Hand-poured soy wax candles, ceramics & aesthetic room decor." },
    { id: "blouses", name: "AariBoutique", label: "Aari & Designer Blouses", icon: "🥻", demo: "blouses", ctr: 0.039, focus: "Readymade Aari work, bridal Maggam blouses & raw silk cuts with sizing." },
    { id: "favors", name: "UtsavFavors", label: "Wedding & Return Favors", icon: "🎁", demo: "favors", ctr: 0.034, focus: "Thamboolam favor bags, brass diya keepsakes & bulk gift hampers." },
    { id: "resin", name: "ResinBlossoms", label: "Garland & Flower Resin", icon: "🌸", demo: "resin", ctr: 0.041, focus: "Wedding varmala preservation clocks, LED bridal lamps & ring platters." },
    { id: "crochet", name: "YarnBlooms", label: "Crochet Bouquets & Plushies", icon: "🧶", demo: "crochet", ctr: 0.038, focus: "Handmade everlasting crochet flower bouquets & amigurumi dolls." },
    { id: "pattu", name: "KuttyPattu", label: "Kids Ethnic & Pattu Pavadai", icon: "🧒", demo: "pattu", ctr: 0.036, focus: "South Indian pattu pavadais, silk dhotis & naming ceremony sets." },
    { id: "linens", name: "DesiLoom", label: "Bedsheets & Dohars", icon: "🛏️", demo: "linens", ctr: 0.033, focus: "100% pure cotton handblock bedsheets, mulmul dohars & artisan durries." },
  ],

  // WHERE TO DO THE LINKINGS (Deep Linking & Traffic Routing Map for ALL 20 STORES + Generic)
  linkingMap: [
    {
      id: "link-g1",
      storeId: "generic",
      storeName: "All Stores",
      angle: "Generic (Time Saver)",
      target: "All Instagram / WhatsApp Sellers",
      destUrl: "https://ownezzy.com/websites",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=generic_time",
      fallback: "https://ownezzy.com#plans",
      hook: "Tired of 100+ DMs? Launch free store in 60s",
      modalTrigger: "10-Second Auto-Modal on Demo Store Preview"
    },
    {
      id: "link-g2",
      storeId: "generic",
      storeName: "All Stores",
      angle: "Generic (0% Commission)",
      target: "High-Volume Resellers & D2C Brands",
      destUrl: "https://ownezzy.com#plans",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=zero_comm",
      fallback: "https://ownezzy.com/websites",
      hook: "Stop paying 25% marketplace cuts · Direct Bank UPI",
      modalTrigger: "Plan Selection Sticky Bar & 7-Day Free Trial CTA"
    },
    {
      id: "link-s1-clothing",
      storeId: "clothing",
      storeName: "UrbanThread",
      angle: "Niche: Clothing & Fashion Boutique",
      target: "Kurti, Saree, Salwar & Lehenga Boutiques",
      destUrl: "https://fashion.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_clothing",
      fallback: "https://ownezzy.com/create/clothing-website",
      hook: "Size & Color Swatches with Instant Instagram Checkout",
      modalTrigger: "10s Modal on Clothing Catalog & Size Guide"
    },
    {
      id: "link-s2-plants",
      storeId: "plants",
      storeName: "GreenNest",
      angle: "Niche: Plants & Gardening",
      target: "Plant Nurseries, Succulents, Ceramic Pots & Seeds",
      destUrl: "https://plants.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_plants",
      fallback: "https://ownezzy.com/websites",
      hook: "Care Guide Filter & Local City Delivery Zones",
      modalTrigger: "10s Modal on Plant Nursery Catalog"
    },
    {
      id: "link-s3-gifts",
      storeId: "gifts",
      storeName: "Giftly",
      angle: "Niche: Gift Hampers & Occasions",
      target: "Personalized Gift Makers, Florists & Chocolate Box Curators",
      destUrl: "https://gifts.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_gifts",
      fallback: "https://ownezzy.com/create/gifts-website",
      hook: "Custom Greeting Card & Gift Wrap Add-on at Checkout",
      modalTrigger: "10s Modal on Gift Hamper Collection"
    },
    {
      id: "link-s4-pets",
      storeId: "pets",
      storeName: "PawPantry",
      angle: "Niche: Pet Store & Accessories",
      target: "Dog/Cat Food Sellers, Pet Groomers, Leashes & Treats",
      destUrl: "https://pet.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_pets",
      fallback: "https://ownezzy.com/websites",
      hook: "Weight-Based Bag Options & Monthly Auto-Replenish Alert",
      modalTrigger: "10s Modal on Pet Treats & Toys Showcase"
    },
    {
      id: "link-s5-aquarium",
      storeId: "aquarium",
      storeName: "AquaLeaf",
      angle: "Niche: Aquarium & Aquatic Plants",
      target: "Exotic Fish Breeders, Planted Tanks & Aquarium Supplies",
      destUrl: "https://aqualeaf.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_aquarium",
      fallback: "https://ownezzy.com/websites",
      hook: "Live Fish Safe Packaging Guarantee & Tank Care Guides",
      modalTrigger: "10s Modal on Planted Tank & Fish Catalog"
    },
    {
      id: "link-s6-wellness",
      storeId: "wellness",
      storeName: "Lather & Bloom",
      angle: "Niche: Organic Soaps & Perfumes",
      target: "Cold-Pressed Soap Makers, Perfumers & Skincare Artisans",
      destUrl: "https://soaps.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_wellness",
      fallback: "https://ownezzy.com/create/beauty-cosmetics-website",
      hook: "100% Organic Ingredient Badges & Bundle Discounts",
      modalTrigger: "10s Modal on Handmade Soap Collection"
    },
    {
      id: "link-s7-footwear",
      storeId: "footwear",
      storeName: "SoleChic",
      angle: "Niche: Footwear & Punjabi Juttis",
      target: "Bridal Mojari, Kolhapuri & Handcrafted Slide Artisans",
      destUrl: "https://footwear.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_footwear",
      fallback: "https://ownezzy.com/create/footwear-website",
      hook: "Interactive Foot Measurement Chart & Real-Time Stock Badges",
      modalTrigger: "10s Modal on Jutti & Mojari Gallery"
    },
    {
      id: "link-s8-uruli",
      storeId: "uruli",
      storeName: "Paramparya",
      angle: "Niche: Traditional Brassware & Bronze Urulis",
      target: "Kumbakonam Bronze Castings, Kuthu Vilakku & Pooja Decor",
      destUrl: "https://uruli.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_uruli",
      fallback: "https://ownezzy.com/create/home-decor-website",
      hook: "Weight-Based Shipping Calculator & Fragile Transit Protection",
      modalTrigger: "10s Modal on Bronze Uruli & Vilakku Catalog"
    },
    {
      id: "link-s9-grocery",
      storeId: "grocery",
      storeName: "DailyBasket",
      angle: "Niche: Grocery & Daily Essentials",
      target: "Local Kiranas, Regional Spices, Dry Fruits & Gourmet Food",
      destUrl: "https://grocery.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_grocery",
      fallback: "https://ownezzy.com/create/grocery-website",
      hook: "1-Click Multi-Add to Cart & Local Pincode Delivery Check",
      modalTrigger: "10s Modal on Daily Essentials & Spices Grid"
    },
    {
      id: "link-s10-fresh",
      storeId: "fresh",
      storeName: "FarmFresh",
      angle: "Niche: Fresh Fruits & Organic Vegetables",
      target: "Farm-to-Door Outlets, Hydroponic Growers & Fruit Baskets",
      destUrl: "https://fresh.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_fresh",
      fallback: "https://ownezzy.com/websites",
      hook: "Morning Harvest Delivery Slots & KG/Bundle Weight Selector",
      modalTrigger: "10s Modal on Fresh Produce Catalog"
    },
    {
      id: "link-s11-tech",
      storeId: "tech",
      storeName: "CaseVault",
      angle: "Niche: Custom Phone Cases & Tech Skins",
      target: "Gen-Z Tech Artists, Case Printers & MagSafe Accessories",
      destUrl: "https://cases.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_cases",
      fallback: "https://ownezzy.com/create/phone-cases-website",
      hook: "Live 3D Phone Model Preview & Custom Artwork Upload",
      modalTrigger: "10s Modal on Phone Skin & Case Studio"
    },
    {
      id: "link-s12-bags",
      storeId: "bags",
      storeName: "ToteVibe",
      angle: "Niche: Canvas Totes & Handbags",
      target: "Eco Canvas Tote Makers, Laptop Sleeves & Sling Bag Sellers",
      destUrl: "https://bags.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_bags",
      fallback: "https://ownezzy.com/websites",
      hook: "Zipper/Pocket Filter & Personalized Monogram Embroidery",
      modalTrigger: "10s Modal on Tote Bags & Sleeves Showcase"
    },
    {
      id: "link-s13-crafts",
      storeId: "crafts",
      storeName: "CraftedCanvas",
      angle: "Niche: Custom Crafts & Art Keepsakes",
      target: "Custom Wood Nameplate Makers, Calligraphers & Resin Artists",
      destUrl: "https://crafts.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_crafts",
      fallback: "https://ownezzy.com/create/crafts-website",
      hook: "Live Custom Name Preview Box & Gift Packaging Selection",
      modalTrigger: "10s Modal on Custom Craft Studio"
    },
    {
      id: "link-s14-decor",
      storeId: "decor",
      storeName: "LuminaNest",
      angle: "Niche: Home Decor & Scented Candles",
      target: "Hand-Poured Soy Candle Makers, Ceramic Vases & Room Decor",
      destUrl: "https://decor.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_decor",
      fallback: "https://ownezzy.com/create/home-decor-website",
      hook: "Fragrance Notes Guide & Aesthetic Room Styling Gallery",
      modalTrigger: "10s Modal on Soy Candle & Decor Collection"
    },
    {
      id: "link-s15-blouses",
      storeId: "blouses",
      storeName: "AariBoutique",
      angle: "Niche: Aari & Designer Bridal Blouses",
      target: "Aari Work, Maggam Embroidery & Custom Blouse Boutiques",
      destUrl: "https://blouses.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_blouses",
      fallback: "https://ownezzy.com/create/clothing-website",
      hook: "Interactive Blouse Neck Selector & Sizing Measurement Form",
      modalTrigger: "10s Modal on Bridal Blouse Studio"
    },
    {
      id: "link-s16-favors",
      storeId: "favors",
      storeName: "UtsavFavors",
      angle: "Niche: Wedding & Return Favors",
      target: "Thamboolam Bags, Brass Diya Gifts, Bulk Wedding Favors",
      destUrl: "https://favors.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_favors",
      fallback: "https://ownezzy.com/websites",
      hook: "Tiered Bulk Quantity Pricing (50/100/500 units) with Free Sample",
      modalTrigger: "10s Modal on Wedding Favor Packs"
    },
    {
      id: "link-s17-resin",
      storeId: "resin",
      storeName: "ResinBlossoms",
      angle: "Niche: Garland & Flower Resin Preservation",
      target: "Wedding Varmala Preservation Clocks, Ring Platters & Lamps",
      destUrl: "https://resin.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_resin",
      fallback: "https://ownezzy.com/create/resin-art-website",
      hook: "Flower Courier Instructions & LED Base Option Selector",
      modalTrigger: "10s Modal on Varmala Preservation Clocks"
    },
    {
      id: "link-s18-crochet",
      storeId: "crochet",
      storeName: "YarnBlooms",
      angle: "Niche: Crochet Bouquets & Amigurumi Dolls",
      target: "Crochet Artists, Forever Flower Bouquets & Plushie Makers",
      destUrl: "https://crochet.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_crochet",
      fallback: "https://ownezzy.com/create/crochet-handicrafts-website",
      hook: "Bouquet Color Palette Customizer & Free Handwritten Note",
      modalTrigger: "10s Modal on Crochet Flower Bouquets"
    },
    {
      id: "link-s19-pattu",
      storeId: "pattu",
      storeName: "KuttyPattu",
      angle: "Niche: Kids Ethnic & Pattu Pavadai",
      target: "South Indian Kids Silk Wear, Pattu Pavadai & Baby Dhotis",
      destUrl: "https://pattu.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_pattu",
      fallback: "https://ownezzy.com/websites",
      hook: "Age-Wise Measurement Table (0-12 yrs) & Pure Cotton Lining Guarantee",
      modalTrigger: "10s Modal on Kids Pattu Pavadai Showcase"
    },
    {
      id: "link-s20-linens",
      storeId: "linens",
      storeName: "DesiLoom",
      angle: "Niche: Handblock Bedsheets & Mulmul Dohars",
      target: "Pure Cotton Handblock Sanganeri Bedsheets & AC Dohars",
      destUrl: "https://linens.ownezzy.com",
      utm: "?utm_source=meta&utm_medium=reels&utm_campaign=niche_linens",
      fallback: "https://ownezzy.com/websites",
      hook: "108x108 King Size Fit Guarantee & 100% Fast Color Assurance",
      modalTrigger: "10s Modal on Handblock Bedsheet Collection"
    }
  ],

  // MASTER ₹10,000 / MONTH ADVERTISING BUDGET ALLOCATION
  budgetPlan10k: {
    monthlyBudget: 10000,
    dailySpend: 333,
    channels: [
      {
        channel: "Meta Ads (Instagram Reels & Stories)",
        monthlyAllocation: 7000,
        pct: 70,
        dailySpend: 233,
        format: "9:16 Vertical Video Reels only",
        targetCampaigns: "Campaign A: South India Blouses (₹140/day) | Campaign B: Custom Phone Cases (₹93/day)",
        notes: "Direct traffic to blouses.ownezzy.com & cases.ownezzy.com with 10s auto-modal"
      },
      {
        channel: "Google Search Ads (Exact Match)",
        monthlyAllocation: 2000,
        pct: 20,
        dailySpend: 66,
        format: "Responsive Search Ads (Exact & Phrase)",
        targetCampaigns: "High-intent keywords ('how to create website for my shop', 'free online store maker india')",
        notes: "Direct traffic to /create/clothing-website and /websites with high commercial intent"
      },
      {
        channel: "WhatsApp Retargeting & Direct Nurture",
        monthlyAllocation: 1000,
        pct: 10,
        dailySpend: 33,
        format: "WhatsApp Cloud API & Direct Automated Alerts",
        targetCampaigns: "Day 0 Welcome, Day 3 Bio-link tutorial, Day 7 Concierge upload, Day 12 ₹399/mo closing",
        notes: "Automated sequence to turn free trials into paid subscriptions"
      }
    ],
    funnelProjections: {
      impressions: "75,000 – 90,000 Views",
      clicks: "2,400 – 2,800 Visitors",
      cpc: "₹2.80 – ₹3.50",
      modalEngagements: "720 – 840 Sellers",
      trialsCreated: "130 – 150 Free Stores",
      trialCost: "₹55 – ₹65 / store",
      paidConversions: "24 – 28 Paid Stores (18.4% CVR)",
      cac: "₹250 – ₹290 / paid store",
      monthlyMrrAdded: "₹10,776 – ₹12,572",
      paybackPeriod: "< 28 Days (Cash flow positive in Month 1)",
      sixMonthRoas: "5.4x – 6.2x Return on Ad Spend"
    },
    weeklyCalendar: [
      {
        week: "Week 1",
        budget: "₹2,500",
        focus: "Creative & Hook Testing",
        tasks: "Deploy 4 video variations (Script 1B Tamil Tanglish, Script 1C GenZ Cases, Script G1 Time-saver, Script G2 Zero-commission). Allocate ₹60/day to find lowest CPC winner."
      },
      {
        week: "Week 2",
        budget: "₹2,500",
        focus: "Scaling Winning Creatives",
        tasks: "Cut the 2 lower-performing ads; direct 80% of budget into top 2 winning Reels. Ensure deep links route directly to blouses.ownezzy.com & cases.ownezzy.com."
      },
      {
        week: "Week 3",
        budget: "₹2,500",
        focus: "WhatsApp Activation & Concierge",
        tasks: "Trigger Day 3 'Add Store Link to Instagram Bio' and Day 7 'Concierge Catalog Upload' sequence for all 70+ trials created to ensure product activation."
      },
      {
        week: "Week 4",
        budget: "₹2,500",
        focus: "Trial-to-Paid Closing & Retargeting",
        tasks: "Send Day 12 ₹399/mo annual plan offer to expiring trials. Re-invest early subscription revenue directly into Month 2 campaign scaling."
      }
    ]
  },

  languages: [
    { id: "en", name: "English", flag: "🇬🇧", badge: "Universal" },
    { id: "hi", name: "Hindi (हिंदी / Hinglish)", flag: "🇮🇳", badge: "North & Central" },
    { id: "ta", name: "Tamil (தமிழ் / Tanglish)", flag: "🇮🇳", badge: "Tamil Nadu" },
    { id: "kn", name: "Kannada (ಕನ್ನಡ / Kanglish)", flag: "🇮🇳", badge: "Karnataka" },
    { id: "ml", name: "Malayalam (മലയാളം / Manglish)", flag: "🇮🇳", badge: "Kerala" }
  ],

  adScripts: {
    en: [
      {
        id: "en-g1",
        type: "generic",
        title: "Script G1: The 4-Hour Daily WhatsApp DM Trap (Time Savings)",
        target: "Home sellers, craftspeople, Instagram boutique owners wasting hours in chat",
        tone: "Empathetic, energetic, liberating",
        destination: "https://ownezzy.com/websites",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller holding phone, scrolling through 200+ unread DMs. Clock ticking fast from 10 AM to 6 PM.",
            voiceover: "Are you still spending 4 hours every single day typing 'Price please' and 'Check DM' on Instagram?",
            textOverlay: "❌ Still typing 'Price Please' for 4 hours a day?"
          },
          {
            time: "4–10s",
            visual: "Seller sends payment QR, customer leaves them on 'Read'. Seller drops head on desk in frustration.",
            voiceover: "Half your customers vanish before sending the payment screenshot. You're losing orders every day.",
            textOverlay: "📉 Customer left you on 'Read'?"
          },
          {
            time: "10–18s",
            visual: "Split screen: Customer clicks one link in bio, selects size, pays instantly via GPay, seller receives automated WhatsApp ping.",
            voiceover: "Meet Ownezzy! Get your own beautiful online store in 60 seconds. Direct UPI payments, automated WhatsApp alerts, and 0% commission.",
            textOverlay: "🚀 Store Live in 60s | ⚡ Direct UPI & WhatsApp Alerts | 💰 0% Commission"
          },
          {
            time: "18–25s",
            visual: "Phone screen displaying pre-built store templates and 7-day free trial card.",
            voiceover: "No coding. No credit card required. Start your 7-day 100% Free Trial right now.",
            textOverlay: "🎁 7-Day Free Trial · No Card Needed"
          },
          {
            time: "25–30s",
            visual: "Creator points downward to the CTA button.",
            voiceover: "Tap the link below and launch your website today!",
            textOverlay: "👉 Tap 'Sign Up' / 'Learn More' 🛍️"
          }
        ]
      },
      {
        id: "en-g2",
        type: "generic",
        title: "Script G2: Stop Paying 25% Marketplace Cuts (0% Commission Focus)",
        target: "Sellers on Meesho, Amazon, Flipkart, Swiggy Minis losing high cuts",
        tone: "Empowering, business-smart, direct",
        destination: "https://ownezzy.com#plans",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller receives a ₹1,000 order, but marketplace takes ₹250 deduction, leaving only ₹750. Seller looks angry.",
            voiceover: "Selling on marketplaces? Why are you giving away 15% to 30% of your hard-earned profits in commissions?",
            textOverlay: "💸 Giving 25% commission to marketplaces?"
          },
          {
            time: "4–10s",
            visual: "Seller calculator showing ₹30,000 lost to platform commissions in one year.",
            voiceover: "That's thousands of rupees lost every single month that should be in your personal bank account!",
            textOverlay: "📉 Stop losing ₹30,000+ every year"
          },
          {
            time: "10–18s",
            visual: "Customer pays ₹1,000 on Ownezzy store; full ₹1,000 lands instantly in seller's PhonePe/GPay with zero deductions.",
            voiceover: "With Ownezzy, customer payments go straight to your bank UPI. 0% platform commission. You keep 100% of your earnings.",
            textOverlay: "⚡ Direct Bank UPI | 💯 100% Profit Yours | 💰 ZERO Commission"
          },
          {
            time: "18–25s",
            visual: "Transparent pricing screen showing ₹399/mo plan.",
            voiceover: "No hidden cuts. Full website, setup, and SSL included. Test it 7 days free.",
            textOverlay: "🌟 ₹399/mo Only · No Hidden Fees"
          },
          {
            time: "25–30s",
            visual: "CTA tap on screen.",
            voiceover: "Click below and stop sharing your profits today!",
            textOverlay: "👉 Claim Your Free Website Now 🚀"
          }
        ]
      },
      {
        id: "en-g3",
        type: "generic",
        title: "Script G3: Why Real Customers Trust Websites Over Chat QR Codes (Credibility)",
        target: "Sellers who lose high-ticket orders because buyers fear online scams in DMs",
        tone: "Professional, reassuring, authoritative",
        destination: "https://ownezzy.com/websites",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Customer hesitating to send ₹2,500 to a random QR code in WhatsApp chat, thinking 'Is this seller real or fake?'.",
            voiceover: "When you ask buyers to scan a random QR code in chat, they wonder: 'Is this seller genuine?'",
            textOverlay: "❓ Will customers trust a random chat QR code?"
          },
          {
            time: "4–10s",
            visual: "Customer closes chat without paying.",
            voiceover: "That hesitation costs you 4 out of every 10 orders before payment.",
            textOverlay: "❌ Lost sales due to lack of trust"
          },
          {
            time: "10–18s",
            visual: "Customer opens an Ownezzy branded website with SSL padlock, logo, clear policies, and instant UPI checkout.",
            voiceover: "An official Ownezzy website gives your brand instant trust. Verified checkout, live tracking, and professional receipts.",
            textOverlay: "🔒 Verified SSL Store | 📦 Automated Tracking | ⭐ Instant Brand Trust"
          },
          {
            time: "18–25s",
            visual: "Free trial badge and easy smartphone admin panel tour.",
            voiceover: "Manage everything from your phone in 2 minutes. Start your 7-day free trial now.",
            textOverlay: "📱 Manage From Phone · 7 Days Free"
          },
          {
            time: "25–30s",
            visual: "Point to link.",
            voiceover: "Tap the link below and turn your shop into a recognized brand!",
            textOverlay: "👉 Launch Your Branded Store Today!"
          }
        ]
      },
      // NICHE VIDEO AD SCRIPTS FOR ALL 20 STORES
      {
        id: "en-s1-clothing",
        type: "niche",
        niche: "clothing",
        storeName: "UrbanThread",
        title: "Store 1: UrbanThread (Clothing, Kurtis & Saree Boutiques)",
        target: "Kurti, saree, salwar suit, and lehenga boutique owners",
        tone: "Chic, trendy, empowering",
        destination: "https://fashion.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller swamped with 50+ DMs asking 'Do you have size L?', 'Show other colors'.",
            voiceover: "Running a clothing boutique on Instagram? Tired of answering size and color queries 100 times a day?",
            textOverlay: "👗 Selling Kurtis & Sarees on Instagram?"
          },
          {
            time: "4–10s",
            visual: "UrbanThread storefront: customer taps Kurti, selects 'Size M' and 'Emerald Green', stock updates live.",
            voiceover: "With Ownezzy, your boutique has automatic size selectors, color swatches, and live stock tracking.",
            textOverlay: "✨ Auto Size & Color Selectors | 📏 Live Stock"
          },
          {
            time: "10–18s",
            visual: "1-Tap UPI payment via PhonePe; seller receives instant WhatsApp order alert with customer address.",
            voiceover: "Customer pays straight to your UPI. 0% platform commission. You keep 100% of your boutique profits.",
            textOverlay: "💰 0% Commission · Direct Bank UPI"
          },
          {
            time: "18–25s",
            visual: "7-day free trial card with fashion template ready.",
            voiceover: "Your clothing store comes pre-loaded with 30 starter designs. Test it free for 7 days.",
            textOverlay: "🎁 7-Day 100% Free Trial"
          },
          {
            time: "25–30s",
            visual: "Tap 'Get Free Store'.",
            voiceover: "Click below and launch your professional boutique in 60 seconds!",
            textOverlay: "👉 Tap 'Start Free Trial' 🛍️"
          }
        ]
      },
      {
        id: "en-s2-plants",
        type: "niche",
        niche: "plants",
        storeName: "GreenNest",
        title: "Store 2: GreenNest (Indoor Plants, Pots & Gardening)",
        target: "Plant nurseries, indoor plant sellers & urban gardening stores",
        tone: "Fresh, calming, nature-inspired",
        destination: "https://plants.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Lush fiddle-leaf figs, monsteras, and ceramic planters being photographed for Instagram.",
            voiceover: "Selling indoor plants from your nursery? Struggling to explain plant sunlight requirements and courier safety in chat?",
            textOverlay: "🌱 Selling Plants on Instagram?"
          },
          {
            time: "4–10s",
            visual: "GreenNest demo store: customer filters by 'Low Light Plants' and picks ceramic pot color.",
            voiceover: "Ownezzy lets customers filter by light care, pick designer pots, and see local delivery zones automatically.",
            textOverlay: "🪴 Plant Care Filters & Pot Selectors"
          },
          {
            time: "10–18s",
            visual: "Safe plant delivery badge and direct UPI payment confirmation.",
            voiceover: "Direct UPI payouts to your bank account with zero commission. Every rupee stays with you.",
            textOverlay: "⚡ Direct UPI Payments | 0% Cut"
          },
          {
            time: "18–25s",
            visual: "Plant store ready in 60s with 30 varieties loaded.",
            voiceover: "No coding needed. Your plant website is ready in 60 seconds. Start your 7-day free trial today.",
            textOverlay: "🌿 7-Day Free Trial · No Card Needed"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Click below and take your nursery online now!",
            textOverlay: "👉 Tap 'Launch Plant Store' 🌱"
          }
        ]
      },
      {
        id: "en-s3-gifts",
        type: "niche",
        niche: "gifts",
        storeName: "Giftly",
        title: "Store 3: Giftly (Personalized Gift Hampers & Occasions)",
        target: "Gift curators, hampers, customized chocolate & anniversary box sellers",
        tone: "Festive, celebratory, heartwarming",
        destination: "https://gifts.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Aesthetic gift hamper with ribbons and fairy lights being hand-packed.",
            voiceover: "Creating custom gift hampers on Instagram? Tired of asking customers for card messages and delivery dates in DMs?",
            textOverlay: "🎁 Selling Custom Gift Hampers?"
          },
          {
            time: "4–10s",
            visual: "Giftly checkout: buyer types 'Happy Anniversary Priya', picks midnight delivery date and luxury gift wrap.",
            voiceover: "Let buyers type their personalized card message, choose delivery dates, and add gift wrap in one clean checkout!",
            textOverlay: "💌 Personalized Card & Delivery Date Picker"
          },
          {
            time: "10–18s",
            visual: "Instant UPI payment and instant WhatsApp confirmation with full gift instructions.",
            voiceover: "Direct UPI payments straight to your personal account. Zero marketplace fees.",
            textOverlay: "💰 100% Profits In Your Bank"
          },
          {
            time: "18–25s",
            visual: "Pre-built gift store template display.",
            voiceover: "Launch your gift boutique in 60 seconds. Test it 100% free for 7 days.",
            textOverlay: "🎀 7-Day 100% Free Trial"
          },
          {
            time: "25–30s",
            visual: "CTA finger tap.",
            voiceover: "Tap below and start delighting gifting customers today!",
            textOverlay: "👉 Tap 'Get Free Gift Store' 🎉"
          }
        ]
      },
      {
        id: "en-s4-pets",
        type: "niche",
        niche: "pets",
        storeName: "PawPantry",
        title: "Store 4: PawPantry (Pet Store, Treats & Accessories)",
        target: "Pet food stores, pet treat makers, and dog/cat accessory shops",
        tone: "Playful, energetic, trustworthy",
        destination: "https://pet.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Cute golden retriever eating organic dog treats, seller packing pet collars and dry food bags.",
            voiceover: "Selling pet treats and accessories? Losing repeating customers because re-ordering in WhatsApp is too clumsy?",
            textOverlay: "🐾 Running a Pet Business on Instagram?"
          },
          {
            time: "4–10s",
            visual: "PawPantry store: buyer selects 3kg grain-free food bag and adds dog chew toy in 1 tap.",
            voiceover: "Give pet parents a clean online pet store with weight-based bags, quick re-ordering, and breed recommendations.",
            textOverlay: "🐶 Weight Selectors & 1-Tap Re-order"
          },
          {
            time: "10–18s",
            visual: "Direct UPI payment with automated dispatch alert.",
            voiceover: "Receive instant UPI payments directly to your bank account with zero sales commission.",
            textOverlay: "⚡ Direct UPI | 0% Platform Fees"
          },
          {
            time: "18–25s",
            visual: "7-day free trial pet template screen.",
            voiceover: "Your pet shop website is ready right now. Try it free for 7 days — no credit card needed.",
            textOverlay: "🦴 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Click below and launch your online pet store in 60 seconds!",
            textOverlay: "👉 Tap 'Launch Pet Store' 🐕"
          }
        ]
      },
      {
        id: "en-s5-aquarium",
        type: "niche",
        niche: "aquarium",
        storeName: "AquaLeaf",
        title: "Store 5: AquaLeaf (Aquarium Fish, Aquatic Plants & Tanks)",
        target: "Aquarium hobbyists, ornamental fish breeders & planted tank stores",
        tone: "Serene, aquatic, authoritative",
        destination: "https://aqualeaf.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Vibrant planted freshwater aquarium with neon tetras and live aquatic moss.",
            voiceover: "Breeding ornamental fish or aquatic plants? Still typing prices for 40 different fish varieties in DMs?",
            textOverlay: "🐠 Selling Aquarium Fish & Plants?"
          },
          {
            time: "4–10s",
            visual: "AquaLeaf demo store: customer filters by freshwater fish, tank accessories, and water condition guides.",
            voiceover: "Ownezzy lets hobbyists browse your live fish catalog, tank accessories, and live plants with transparent pricing.",
            textOverlay: "🌿 Live Aquatic Catalog & Tank Care Guides"
          },
          {
            time: "10–18s",
            visual: "Safe live fish transit badge and UPI checkout.",
            voiceover: "Customers pay directly on UPI. ZERO platform deductions. You keep 100% of every sale.",
            textOverlay: "💰 0% Commission · Direct Bank UPI"
          },
          {
            time: "18–25s",
            visual: "Aquarium template preview.",
            voiceover: "No web developer needed. Your aquarium website is live in 60 seconds. Test it free for 7 days.",
            textOverlay: "🌊 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Tap 'Get Free Store'.",
            voiceover: "Tap the link below and take your aquarium business online today!",
            textOverlay: "👉 Tap 'Try Aquarium Demo' 🐟"
          }
        ]
      },
      {
        id: "en-s6-wellness",
        type: "niche",
        niche: "wellness",
        storeName: "Lather & Bloom",
        title: "Store 6: Lather & Bloom (Handmade Soaps & Perfumes)",
        target: "Cold-pressed soap makers, organic skincare artisans & perfumers",
        tone: "Luxurious, botanical, soothing",
        destination: "https://soaps.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Artisanal cold-pressed soap bars being cut with botanical swirls; aesthetic glass perfume vials.",
            voiceover: "Crafting organic soaps and perfumes? Losing sales because buyers don't know your ingredient safety or scent notes?",
            textOverlay: "🧼 Selling Handmade Soaps & Perfumes?"
          },
          {
            time: "4–10s",
            visual: "Lather & Bloom store: customer views lavender soap with certified organic badge and scent profile.",
            voiceover: "Showcase your natural ingredients, scent profiles, and bundle gift sets in an elegant boutique layout.",
            textOverlay: "🌸 Ingredient Transparency & Scent Notes"
          },
          {
            time: "10–18s",
            visual: "Customer buys 3 soap combo pack, pays instantly via GPay.",
            voiceover: "All earnings go straight to your bank account with zero commission. Keep every rupee you craft.",
            textOverlay: "⚡ Direct Bank UPI | 0% Platform Fees"
          },
          {
            time: "18–25s",
            visual: "Wellness store template preview.",
            voiceover: "Your soap and perfume store is built and ready. Test it free for 7 days — no credit card needed.",
            textOverlay: "🌿 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap below and give your organic brand the professional home it deserves!",
            textOverlay: "👉 Tap 'Start Free Trial' ✨"
          }
        ]
      },
      {
        id: "en-s7-footwear",
        type: "niche",
        niche: "footwear",
        storeName: "SoleChic",
        title: "Store 7: SoleChic (Footwear, Punjabi Juttis & Mojaris)",
        target: "Jutti makers, Kolhapuri artisans, bridal footwear & cushioned slide brands",
        tone: "Festive, handcrafted, vibrant",
        destination: "https://footwear.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Intricate hand-embroidered Punjabi juttis with mirrorwork, seller answering 'Is size 38 available in pink?'.",
            voiceover: "Selling handcrafted juttis or shoes on Instagram? Spending all evening answering shoe size and color availability?",
            textOverlay: "👡 Selling Punjabi Juttis on Instagram?"
          },
          {
            time: "4–10s",
            visual: "SoleChic store: customer clicks Euro size chart, selects Size 38, sees exact in-stock pairs.",
            voiceover: "Ownezzy provides built-in shoe size conversion charts and real-time inventory management.",
            textOverlay: "👠 Footwear Sizing Chart & Stock Counts"
          },
          {
            time: "10–18s",
            visual: "Direct UPI checkout with instant address capture.",
            voiceover: "Customer pays on UPI. 0% commission. Full profits stay in your bank.",
            textOverlay: "💰 0% Commission · Direct Bank UPI"
          },
          {
            time: "18–25s",
            visual: "Footwear template showcase.",
            voiceover: "Your footwear store is already loaded with 30 starter designs. Test it 100% free for 7 days.",
            textOverlay: "✨ 7-Day Free Trial · Ready in 60s"
          },
          {
            time: "25–30s",
            visual: "CTA button.",
            voiceover: "Click below and step into a professional footwear store today!",
            textOverlay: "👉 Tap 'Get Footwear Store' 🥿"
          }
        ]
      },
      {
        id: "en-s8-uruli",
        type: "niche",
        niche: "uruli",
        storeName: "Paramparya",
        title: "Store 8: Paramparya (Brassware & Bronze Urulis)",
        target: "Bronze casting artisans, pooja decor, Kumbakonam bronze & brass sellers",
        tone: "Traditional, grand, authentic South Indian",
        destination: "https://uruli.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Stunning Kumbakonam bronze uruli with floating jasmine flowers and lit brass diyas.",
            voiceover: "Selling traditional bronze urulis and brassware? Tired of arguing over weight-based courier charges in chat?",
            textOverlay: "🪔 Selling Traditional Brassware & Urulis?"
          },
          {
            time: "4–10s",
            visual: "Paramparya store: customer enters pincode, weight-based courier fee calculates automatically with fragile packing.",
            voiceover: "Ownezzy calculates exact courier rates automatically based on heavy item weight and destination pincode.",
            textOverlay: "⚖️ Auto Weight Shipping & Fragile Packing"
          },
          {
            time: "10–18s",
            visual: "High-ticket ₹4,800 bronze uruli paid via UPI.",
            voiceover: "Direct UPI payments straight to your bank account with zero sales commission. Keep 100% of your earnings.",
            textOverlay: "💸 0% Commission · Direct Bank Payout"
          },
          {
            time: "18–25s",
            visual: "Ready-to-use brassware template screen.",
            voiceover: "Your brass store is ready in 60 seconds. Test it free for 7 days — no credit card needed.",
            textOverlay: "🌟 7-Day 100% Free Trial"
          },
          {
            time: "25–30s",
            visual: "CTA tap.",
            voiceover: "Tap below and showcase your heritage crafts to all of India!",
            textOverlay: "👉 Tap 'Launch Brass Store' 🪔"
          }
        ]
      },
      {
        id: "en-s9-grocery",
        type: "niche",
        niche: "grocery",
        storeName: "DailyBasket",
        title: "Store 9: DailyBasket (Grocery & Regional Food Essentials)",
        target: "Kirana stores, artisanal spice makers, organic cold-pressed oil brands",
        tone: "Fast, everyday, neighborhood-friendly",
        destination: "https://grocery.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Packets of stone-ground sambar powder, cold-pressed sesame oil, and daily pantry staples.",
            voiceover: "Selling organic spices or pantry staples? Customers sending long messy grocery lists as WhatsApp photos?",
            textOverlay: "🛒 Running an Online Grocery / Spice Business?"
          },
          {
            time: "4–10s",
            visual: "DailyBasket store: customer rapidly taps '+ Add' across 5 items in 10 seconds, cart totals automatically.",
            voiceover: "Give your regular buyers a fast digital storefront with 1-click cart, pincode check, and bulk combo discounts.",
            textOverlay: "⚡ Fast 1-Click Cart & Combo Multi-Packs"
          },
          {
            time: "10–18s",
            visual: "Customer pays via GPay; phone rings with order bell alert.",
            voiceover: "Direct UPI payments to your account. 0% platform cuts. Keep every single rupee of profit.",
            textOverlay: "💰 0% Commission · Instant Bank UPI"
          },
          {
            time: "18–25s",
            visual: "Grocery store template preview.",
            voiceover: "Your grocery store is ready in 60 seconds. Start your 7-day free trial right now.",
            textOverlay: "📦 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Click below and take your grocery store online today!",
            textOverlay: "👉 Tap 'Start Grocery Store' 🛒"
          }
        ]
      },
      {
        id: "en-s10-fresh",
        type: "niche",
        niche: "fresh",
        storeName: "FarmFresh",
        title: "Store 10: FarmFresh (Fresh Fruits & Organic Vegetables)",
        target: "Farm-to-home produce, hydroponic growers, seasonal fruit box sellers",
        tone: "Crisp, healthy, energetic",
        destination: "https://fresh.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Dew-kissed organic tomatoes, crisp greens, and exotic dragon fruits being harvested.",
            voiceover: "Selling farm-fresh fruits or organic vegetables? Struggling with daily price updates and morning delivery slots?",
            textOverlay: "🥬 Selling Fresh Produce Online?"
          },
          {
            time: "4–10s",
            visual: "FarmFresh store: buyer picks 1kg Alphonso mangoes, selects 'Morning 7-9 AM Slot', adds organic spinach.",
            voiceover: "Ownezzy lets you update daily market rates in 5 seconds and let customers pick morning delivery time slots.",
            textOverlay: "⏰ Delivery Time Slots & 5s Price Updates"
          },
          {
            time: "10–18s",
            visual: "Instant UPI payout and digital delivery slip generated.",
            voiceover: "Instant UPI payments directly to your bank account with ZERO commission.",
            textOverlay: "⚡ Direct Bank UPI | 0% Cut"
          },
          {
            time: "18–25s",
            visual: "FarmFresh template ready screen.",
            voiceover: "Get your fresh produce store live in 60 seconds. Test it 100% free for 7 days.",
            textOverlay: "🍎 7-Day Free Trial · No Card Needed"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap below and deliver fresh goodness to your city!",
            textOverlay: "👉 Tap 'Start Fresh Store' 🥦"
          }
        ]
      },
      {
        id: "en-s11-tech",
        type: "niche",
        niche: "tech",
        storeName: "CaseVault",
        title: "Store 11: CaseVault (Custom Phone Cases & Tech Skins)",
        target: "Gen-Z phone case printers, device skin artists & MagSafe creators",
        tone: "Fast-paced, vibrant, modern",
        destination: "https://cases.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Fast aesthetic cuts of anime, cyberpunk, and marble phone cases being printed and packaged.",
            voiceover: "Selling custom phone cases on Instagram? Still asking customers for their phone model and photo in DMs?",
            textOverlay: "📱 Selling Phone Cases on Instagram?"
          },
          {
            time: "4–10s",
            visual: "CaseVault Studio: customer selects iPhone 15 Pro, uploads art, sees interactive 3D model skin preview.",
            voiceover: "Give your buyers a live skin preview where they pick their phone model, upload artwork, and order in seconds.",
            textOverlay: "🎨 Live Phone Model & Sticker Preview"
          },
          {
            time: "10–18s",
            visual: "Swift UPI checkout with PhonePe / GPay badge.",
            voiceover: "Instant payments via UPI. Zero transaction commission. 100% profit in your bank.",
            textOverlay: "⚡ Instant UPI · 0% Cut"
          },
          {
            time: "18–25s",
            visual: "Phone case template preview with 30 designs.",
            voiceover: "Your case store is already built with 30 trending designs. Activate your 7-day free trial with one tap.",
            textOverlay: "🔥 7-Day 100% Free Trial"
          },
          {
            time: "25–30s",
            visual: "CTA finger tap.",
            voiceover: "Tap the link below and turn your page into a professional brand!",
            textOverlay: "👉 Tap 'Order Demo' Now!"
          }
        ]
      },
      {
        id: "en-s12-bags",
        type: "niche",
        niche: "bags",
        storeName: "ToteVibe",
        title: "Store 12: ToteVibe (Canvas Totes & Handbags)",
        target: "Canvas tote artists, padded laptop sleeve makers, aesthetic sling bag brands",
        tone: "Minimalist, aesthetic, eco-conscious",
        destination: "https://bags.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Aesthetic beige cotton canvas totes with floral typography, padded pastel laptop bags.",
            voiceover: "Selling aesthetic canvas totes or laptop sleeves? Tired of explaining bag dimensions and pocket details in chat?",
            textOverlay: "👜 Selling Canvas Totes & Bags?"
          },
          {
            time: "4–10s",
            visual: "ToteVibe demo store: customer filters by 15.6-inch laptop size, picks zipper vs magnet closure, adds monogram.",
            voiceover: "Showcase internal compartments, laptop sleeve padding, and custom monogram initials in a sleek lookbook.",
            textOverlay: "💻 Laptop Size Selectors & Monogram Preview"
          },
          {
            time: "10–18s",
            visual: "Quick UPI payment with PhonePe.",
            voiceover: "Customer money goes directly into your bank account. ZERO sales commission.",
            textOverlay: "💰 0% Commission · 100% Profit"
          },
          {
            time: "18–25s",
            visual: "Tote store template display.",
            voiceover: "No coding needed. Your tote bag website is ready in 60 seconds. Test it free for 7 days.",
            textOverlay: "🌿 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Click below and carry your bag business to the next level!",
            textOverlay: "👉 Tap 'Start Bag Store' 🛍️"
          }
        ]
      },
      {
        id: "en-s13-crafts",
        type: "niche",
        niche: "crafts",
        storeName: "CraftedCanvas",
        title: "Store 13: CraftedCanvas (Custom Crafts & Art Keepsakes)",
        target: "Custom wood nameplates, resin clocks, clay charms & personalized crafters",
        tone: "Heartfelt, creative, artisan-first",
        destination: "https://crafts.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Handcrafted wooden home entrance nameplate being engraved with golden lettering.",
            voiceover: "Making custom nameplates or handmade crafts? Tired of spelling mistakes discussed back-and-forth in WhatsApp?",
            textOverlay: "🧵 Custom Nameplates & Handmade Crafts?"
          },
          {
            time: "4–10s",
            visual: "CraftedCanvas store: customer enters family names: 'The Sharmas - Flat 402', sees live font preview.",
            voiceover: "Buyers type their exact custom text and upload reference photos directly during checkout without errors.",
            textOverlay: "✍️ Custom Text Input & Font Preview"
          },
          {
            time: "10–18s",
            visual: "Advance payment collected via UPI.",
            voiceover: "Collect full advance payment safely on UPI. Zero commission deductions.",
            textOverlay: "⚡ Advance UPI Payment | 0% Cut"
          },
          {
            time: "18–25s",
            visual: "Craft store template ready screen.",
            voiceover: "Your custom craft website is ready in 60 seconds. Test it 100% free for 7 days.",
            textOverlay: "🎨 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap below and start accepting structured custom craft orders!",
            textOverlay: "👉 Tap 'Get Craft Store' ✨"
          }
        ]
      },
      {
        id: "en-s14-decor",
        type: "niche",
        niche: "decor",
        storeName: "LuminaNest",
        title: "Store 14: LuminaNest (Home Decor & Scented Candles)",
        target: "Soy wax candle makers, ceramic artisans & boho home decor curators",
        tone: "Cozy, warm, aesthetic, premium",
        destination: "https://decor.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Flickering amber glass candle with wooden wick, ceramic textured vase, and cozy bedroom lighting.",
            voiceover: "Making hand-poured soy candles or room decor? Struggling to convey your fragrance notes in Instagram captions?",
            textOverlay: "🕯️ Selling Scented Candles & Decor?"
          },
          {
            time: "4–10s",
            visual: "LuminaNest demo: customer reads 'Vanilla & Amberwood' top/middle/base notes and bundle discount.",
            voiceover: "Highlight burn time, natural soy wax benefits, and fragrance pyramids in a stunning aesthetic layout.",
            textOverlay: "✨ Fragrance Notes & Burn Time Badges"
          },
          {
            time: "10–18s",
            visual: "Customer orders 2 candles, pays via UPI with zero transaction fee.",
            voiceover: "All payments go straight to your bank account. ZERO platform commission.",
            textOverlay: "💰 Direct Bank UPI · 0% Cut"
          },
          {
            time: "18–25s",
            visual: "Home decor template ready screen.",
            voiceover: "Launch your home decor website in 60 seconds. Test it free for 7 days — no credit card needed.",
            textOverlay: "🌟 7-Day 100% Free Trial"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap the link below and make your candle brand glow!",
            textOverlay: "👉 Tap 'Start Decor Store' 🕯️"
          }
        ]
      },
      {
        id: "en-s15-blouses",
        type: "niche",
        niche: "blouses",
        storeName: "AariBoutique",
        title: "Store 15: AariBoutique (Aari & Designer Bridal Blouses)",
        target: "Aari work, Maggam bridal embroidery, custom blouse boutiques in South India",
        tone: "Artisan-focused, royal crimson, professional",
        destination: "https://blouses.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Intricate bridal Aari embroidery work, followed by WhatsApp messages asking 'What is chest 36 price?'.",
            voiceover: "Running an Aari blouse or boutique business on Instagram? Tired of sending design photos and measurements in chat?",
            textOverlay: "👗 Running an Aari Boutique on Instagram?"
          },
          {
            time: "4–10s",
            visual: "AariBoutique demo: selecting sleeve length, neck design, and fabric colors with real-time preview.",
            voiceover: "Upgrade your boutique to an automated website where clients pick neckline cuts, measurements, and place orders directly!",
            textOverlay: "✂️ Blouse Customization Studio | 📏 Auto Measurements"
          },
          {
            time: "10–18s",
            visual: "Customer taps 'Pay with UPI', instant WhatsApp order ping: 'New Bridal Blouse Order received: ₹3,500'.",
            voiceover: "Payments go straight to your UPI account. And Ownezzy charges ZERO percent commission.",
            textOverlay: "📱 Direct UPI to Your Bank | 💸 0% Commission"
          },
          {
            time: "18–25s",
            visual: "7-day free trial boutique template preview.",
            voiceover: "Your boutique store is already designed and ready. Test it 100% free for 7 days — no card needed.",
            textOverlay: "🌸 7-Day Free Trial Live Demo"
          },
          {
            time: "25–30s",
            visual: "Tap 'Get Free Store'.",
            voiceover: "Click the link below and start your online boutique in 60 seconds!",
            textOverlay: "👉 Click Link in Bio / Learn More"
          }
        ]
      },
      {
        id: "en-s16-favors",
        type: "niche",
        niche: "favors",
        storeName: "UtsavFavors",
        title: "Store 16: UtsavFavors (Wedding & Return Favors)",
        target: "Wedding favor curators, Thamboolam bag suppliers & festive gift hampers",
        tone: "Grand, auspicious, celebratory",
        destination: "https://favors.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Golden brass diya favors, jute Thamboolam bags, and Chettinad palm leaf boxes arranged in hundreds.",
            voiceover: "Supplying bulk wedding return gifts or Thamboolam bags? Losing clients who want tiered bulk wholesale pricing?",
            textOverlay: "🎁 Selling Wedding Return Gifts in Bulk?"
          },
          {
            time: "4–10s",
            visual: "UtsavFavors store: customer selects '100 Packs', price drops automatically from ₹150 to ₹110/pack.",
            voiceover: "Ownezzy automatically applies tiered bulk discounts for 50, 100, or 500 gift packs in real time.",
            textOverlay: "📦 Tiered Bulk Pricing (50 / 100 / 500 Units)"
          },
          {
            time: "10–18s",
            visual: "Customer books sample pack first via UPI.",
            voiceover: "Direct UPI payments with zero commission deductions. All earnings land straight in your bank.",
            textOverlay: "💰 0% Platform Fees · Direct UPI"
          },
          {
            time: "18–25s",
            visual: "Wedding favor template display.",
            voiceover: "Your wedding favor store is ready in 60 seconds. Test it free for 7 days — no card required.",
            textOverlay: "🌟 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap below and scale your wedding gift business today!",
            textOverlay: "👉 Tap 'Start Favor Store' 🎁"
          }
        ]
      },
      {
        id: "en-s17-resin",
        type: "niche",
        niche: "resin",
        storeName: "ResinBlossoms",
        title: "Store 17: ResinBlossoms (Garland & Flower Resin Preservation)",
        target: "Wedding varmala preservation artists, floral resin clock & ring platter makers",
        tone: "Emotional, sentimental, exquisite",
        destination: "https://resin.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Brilliant crystal-clear resin clock preserving red wedding roses and gold flakes with roman numerals.",
            voiceover: "Preserving wedding varmalas and bridal bouquets in resin? Answering the same flower drying and courier questions in 50 DMs?",
            textOverlay: "🌸 Varmala Flower Resin Preservation?"
          },
          {
            time: "4–10s",
            visual: "ResinBlossoms store: customer picks 12-inch wall clock, selects LED wooden base, and views flower shipping guide.",
            voiceover: "Provide automated flower courier instructions, shape choices, and LED base options in one seamless checkout.",
            textOverlay: "⏰ Clock Shapes, LED Bases & Courier Guide"
          },
          {
            time: "10–18s",
            visual: "Advance ₹2,000 booking deposit paid via UPI.",
            voiceover: "Collect non-refundable booking advances via direct UPI with zero platform cuts.",
            textOverlay: "⚡ Advance Booking UPI | 0% Commission"
          },
          {
            time: "18–25s",
            visual: "Resin preservation template ready.",
            voiceover: "Launch your resin preservation website in 60 seconds. Test it free for 7 days.",
            textOverlay: "💍 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Click below and turn memories into lifelong masterpieces!",
            textOverlay: "👉 Tap 'Get Resin Store' 🌸"
          }
        ]
      },
      {
        id: "en-s18-crochet",
        type: "niche",
        niche: "crochet",
        storeName: "YarnBlooms",
        title: "Store 18: YarnBlooms (Crochet Bouquets & Plushies)",
        target: "Crochet artisans, everlasting flower bouquet makers, amigurumi doll creators",
        tone: "Whimsical, adorable, cozy",
        destination: "https://crochet.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Handmade pastel crochet tulips, daisies, and lavender bouquets wrapped in Korean paper with fairy lights.",
            voiceover: "Crafting crochet flower bouquets or amigurumi dolls? Tired of discussing stem combinations one by one in chat?",
            textOverlay: "🧶 Selling Handmade Crochet Bouquets?"
          },
          {
            time: "4–10s",
            visual: "YarnBlooms store: buyer picks '7-Stem Pastel Bouquet', chooses color scheme, adds custom handwritten note.",
            voiceover: "Let buyers customize flower stem counts, color palettes, and add gift wrapping with zero confusion.",
            textOverlay: "💐 Stem Count & Color Palette Customizer"
          },
          {
            time: "10–18s",
            visual: "Customer pays via GPay; phone sounds instant audio order alert.",
            voiceover: "Instant UPI payments straight to your bank account with ZERO commission. You keep 100% of your handwork.",
            textOverlay: "💰 100% Profit Yours · 0% Cut"
          },
          {
            time: "18–25s",
            visual: "Crochet store template preview.",
            voiceover: "Your crochet website is built and ready in 60 seconds. Test it free for 7 days.",
            textOverlay: "🎁 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap below and bloom your crochet business across India!",
            textOverlay: "👉 Tap 'Start Crochet Store' 🧶"
          }
        ]
      },
      {
        id: "en-s19-pattu",
        type: "niche",
        niche: "pattu",
        storeName: "KuttyPattu",
        title: "Store 19: KuttyPattu (Kids Ethnic & Pattu Pavadai)",
        target: "South Indian kids traditional wear, baby dhotis, naming ceremony pattu pavadais",
        tone: "Traditional, affectionate, vibrant South Indian",
        destination: "https://pattu.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Adorable South Indian toddler girl in golden and magenta silk pattu pavadai; boy in baby silk dhoti.",
            voiceover: "Selling kids pattu pavadai or festive wear? Parents repeatedly asking about child age sizing and pure cotton lining?",
            textOverlay: "🧒 Selling Kids Pattu Pavadai & Ethnic Wear?"
          },
          {
            time: "4–10s",
            visual: "KuttyPattu store: mother selects 'Age 2-3 Years', sees chest and skirt length chart with cotton lining guarantee.",
            voiceover: "Ownezzy gives parents clear age-based measurement charts (0–12 yrs) and fabric lining guarantees for peace of mind.",
            textOverlay: "📏 Age Measurement Guide (0-12 yrs) & Cotton Lining"
          },
          {
            time: "10–18s",
            visual: "Direct UPI payment with instant WhatsApp order confirmation.",
            voiceover: "Direct UPI payments straight to your bank account with zero commission. Every rupee is yours.",
            textOverlay: "⚡ Direct Bank UPI · 0% Cut"
          },
          {
            time: "18–25s",
            visual: "KuttyPattu template ready screen.",
            voiceover: "Your kids ethnic store is ready in 60 seconds. Test it 100% free for 7 days — no card needed.",
            textOverlay: "🌸 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Tap 'Get Free Store'.",
            voiceover: "Click below and dress little princes and princesses online!",
            textOverlay: "👉 Tap 'Launch Kids Store' 🥻"
          }
        ]
      },
      {
        id: "en-s20-linens",
        type: "niche",
        niche: "linens",
        storeName: "DesiLoom",
        title: "Store 20: DesiLoom (Handblock Bedsheets & Mulmul Dohars)",
        target: "Sanganeri handblock bedsheet sellers, Jaipuri mulmul AC dohars, home linen brands",
        tone: "Heritage, breathable, comfort-centric",
        destination: "https://linens.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Artisan hand-stamping indigo blocks on 100% cotton fabric; plush king-size bed made up with Sanganeri prints.",
            voiceover: "Selling handblock bedsheets or Jaipuri dohars? Buyers always asking 'Is this King size 108x108?' and 'Will colors bleed?'.",
            textOverlay: "🛏️ Selling Handblock Bedsheets & Dohars?"
          },
          {
            time: "4–10s",
            visual: "DesiLoom store: customer filters by 'King 108x108', views matching pillow covers, and sees fast-color certification.",
            voiceover: "Highlight thread counts, king-size mattress dimensions, and reversible mulmul layers with zero doubts.",
            textOverlay: "👑 King 108x108 Filter & 100% Cotton Badges"
          },
          {
            time: "10–18s",
            visual: "Customer orders 2 bedsheets + 1 AC dohar, pays on UPI without deductions.",
            voiceover: "Customer money goes directly to your bank account. ZERO marketplace commissions.",
            textOverlay: "💰 0% Commission · 100% Profit"
          },
          {
            time: "18–25s",
            visual: "DesiLoom template preview screen.",
            voiceover: "Your home linen store is ready in 60 seconds. Test it free for 7 days — no credit card needed.",
            textOverlay: "🌿 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "Call to action.",
            voiceover: "Tap below and drape homes across India in your handblock linens!",
            textOverlay: "👉 Tap 'Start Linen Store' 🛏️"
          }
        ]
      }
    ],

    hi: [
      {
        id: "hi-2a",
        type: "generic",
        title: "Script 2A: Generic (Home Businesses & Small Sellers)",
        target: "Instagram home entrepreneurs across Delhi NCR, UP, MP, Maharashtra, Rajasthan",
        tone: "Relatable, energetic, Hindi/Hinglish",
        destination: "https://ownezzy.com/websites",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller typing on phone frustatedly, endless DM notifications popping up.",
            voiceover: "क्या आप भी रोज़ इंस्टाग्राम पर 'Price Please' और 'Check DM' लिखते-लिखते थक चुके हैं?",
            textOverlay: "❌ Roz 100+ 'Price Please' DMs se pareshan?"
          },
          {
            time: "4–10s",
            visual: "Customer asks 'Bhai QR code bhejo', seller sends QR, customer ghosts.",
            voiceover: "आधे कस्टमर्स तो पेमेंट का स्क्रीनशॉट भेजने से पहले ही गायब हो जाते हैं! हर दिन आपकी सेल्स का नुकसान हो रहा है।",
            textOverlay: "📉 Customer payment se pehle gayab?"
          },
          {
            time: "10–18s",
            visual: "Customer opens mobile site, clicks product, selects size, pays with GPay, instant order notification on seller's WhatsApp.",
            voiceover: "अब अपनाइए Ownezzy! सिर्फ 60 सेकंड में अपनी खुद की ऑनलाइन स्टोर वेबसाइट शुरू करें। डायरेक्ट UPI पेमेंट्स, WhatsApp आर्डर अलर्ट्स, और ZERO कमीशन!",
            textOverlay: "🚀 60 Seconds Me Apni Website | ⚡ Direct UPI & WhatsApp Alerts | 💰 0% Commission"
          },
          {
            time: "18–25s",
            visual: "Display 7-day free trial, no credit card screen.",
            voiceover: "कोई कोडिंग नहीं, कोई क्रेडिट कार्ड नहीं चाहिए। आज ही शुरू करें अपना 7-Day 100% Free Trial.",
            textOverlay: "🎁 7-Day Free Trial · No Card Needed"
          },
          {
            time: "25–30s",
            visual: "Call to action button tap.",
            voiceover: "नीचे दिए गए लिंक पर तुरंत क्लिक करें और अपनी वेबसाइट अभी लाइव करें!",
            textOverlay: "👉 Click 'Sign Up' / 'Learn More' 📲"
          }
        ]
      },
      {
        id: "hi-2b",
        type: "niche",
        niche: "blouses",
        title: "Script 2B: Niche-Specific (Boutique, Suits, Sarees & Kurtis)",
        target: "Boutique designers, saree & kurti sellers across North and Central India",
        tone: "Polished, welcoming, commercial",
        destination: "https://blouses.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Designer suits, sarees, and boutique embroidery close-ups.",
            voiceover: "अगर आप इंस्टाग्राम पर बुटीक, सूट या साड़ियों का बिज़नेस करते हैं, तो DM में बार-बार साइज़ और रेट बताना बंद कीजिए!",
            textOverlay: "👗 Instagram Boutique Seller?"
          },
          {
            time: "4–10s",
            visual: "Customer selecting blouse neck design, entering bust/waist size in 3 taps.",
            voiceover: "Ownezzy पर पाइए अपनी रेडीमेड बुटीक वेबसाइट—जहाँ कस्टमर खुद डिज़ाइन चुनेगा, नाप डालेगा और आर्डर प्लेस करेगा।",
            textOverlay: "✨ Custom Size & Design Selector"
          },
          {
            time: "10–18s",
            visual: "Payment confirms directly to seller's UPI.",
            voiceover: "पैसा सीधा आपके बैंक अकाउंट में, और Ownezzy आपसे कोई कमीशन नहीं लेता!",
            textOverlay: "💸 0% Commission · Direct Bank UPI"
          },
          {
            time: "18–25s",
            visual: "Free trial card with golden badge.",
            voiceover: "आपकी बुटीक वेबसाइट पहले से ही तैयार है। 14 दिनों तक बिल्कुल फ्री इस्तेमाल करें—कोई कार्ड नहीं चाहिए!",
            textOverlay: "🌟 14 Din Bilkul Free Trial"
          },
          {
            time: "25–30s",
            visual: "CTA pointer.",
            voiceover: "नीचे लिंक पर टैप करें और आज ही अपना बुटीक ऑनलाइन ले जाएं!",
            textOverlay: "👉 Abhi Link Par Click Karein!"
          }
        ]
      }
    ],

    ta: [
      {
        id: "ta-3a",
        type: "generic",
        title: "Script 3A: Generic (Tamil Nadu Instagram & WhatsApp Sellers)",
        target: "Chennai, Coimbatore, Madurai, Salem, Tirupur, Trichy sellers",
        tone: "Friendly, conversational, practical Tanglish",
        destination: "https://ownezzy.com/websites",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller sitting with mobile, notifications dinging non-stop.",
            voiceover: "Instagram-la business pandreengala? Innum daily 'Price please' nu DM-la type panni tired aagiteengala?",
            voiceoverLocal: "இன்ஸ்டாகிராம்ல பிசினஸ் பண்றீங்களா? தினமும் 'Price please'-க்கு பதில் சொல்லி அலுத்துப்போச்சா?",
            textOverlay: "❌ Innum 'Price Please' DM-la reply panreengala?"
          },
          {
            time: "4–10s",
            visual: "GPay screenshot request ignored in chat.",
            voiceover: "Customer GPay number kekuranga, aana payment pannaama ghost aagiduraanga. Ippadi evlo orders miss aagudhu theriyuma?",
            voiceoverLocal: "கஸ்டமர் GPay நம்பர் கேட்டுட்டு பேமெண்ட் பண்ணாம போயிடுறாங்களா?",
            textOverlay: "📉 Ghost aagura customers & Lost orders"
          },
          {
            time: "10–18s",
            visual: "Mobile screen shows Ownezzy store, instant product buy with UPI, WhatsApp message pinging.",
            voiceover: "Idhuku dhaan Ownezzy! Just 60 seconds-la unga brand-ku oru professional website. Direct UPI payment, WhatsApp order alert, and முக்கியமா ZERO commission!",
            voiceoverLocal: "60 நொடியில் உங்கள் ஆன்லைன் ஸ்டோர்! நேரடி UPI & ஜீரோ கமிஷன்!",
            textOverlay: "🚀 60 Sec-la Unga Website! | ⚡ Direct PhonePe / GPay | 💰 0% Commission"
          },
          {
            time: "18–25s",
            visual: "7-day free trial card.",
            voiceover: "Coding theva illa, credit card-um theva illa. 7 days 100% Free Trial-ah ippove try pannunga.",
            voiceoverLocal: "கிரெடிட் கார்டு தேவையில்லை · 14 நாட்கள் இலவச டிரையல்",
            textOverlay: "🎁 7-Day Free Trial · Card Theva Illa"
          },
          {
            time: "25–30s",
            visual: "Finger points to ad link.",
            voiceover: "Keezha irukura link-ah click panni, unga website-ah innike start pannunga!",
            voiceoverLocal: "இப்போதே கீழே உள்ள லிங்கை கிளிக் செய்யுங்கள்!",
            textOverlay: "👉 Click Link Below / Learn More 🛍️"
          }
        ]
      },
      {
        id: "ta-3b",
        type: "niche",
        niche: "blouses",
        title: "Script 3B: Niche-Specific (Aari Work, Bridal Blouses & Pattu Pavadai)",
        target: "Tamil Nadu boutique designers & home tailors",
        tone: "Authentic, respectful of craftsmanship, Tanglish",
        destination: "https://blouses.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Grand Aari zari thread work and bridal blouse photoshoot.",
            voiceover: "Aari work blouses matrum bridal boutique business pandreengala? Customer kitta measurements-um designs-um WhatsApp-la vangi romba kashtapadreengala?",
            voiceoverLocal: "ஆரி ஒர்க் & புட்டிக் பிசினஸ் பண்றீங்களா?",
            textOverlay: "👗 Aari Blouse & Boutique Sellers"
          },
          {
            time: "4–10s",
            visual: "Blouse Design Studio on phone: picking sleeve, neck cut, and entering measurements.",
            voiceover: "Ownezzy-la unga boutique-kaaga ready-made website irukku! Client-ey blouse design, size, color select panni direct-ah order pannuvaanga.",
            voiceoverLocal: "கஸ்டமர் பிளவுஸ் டிசைன் & அளவுகளை ஈஸியா செலக்ட் பண்ணலாம்!",
            textOverlay: "✂️ Blouse Customizer & Size Selection"
          },
          {
            time: "10–18s",
            visual: "UPI payment rings on phone: ₹4,500 received.",
            voiceover: "Direct UPI payment unga bank account-ku varum. Ownezzy unga kitta 1 rooba kooda commission edukaadhu!",
            voiceoverLocal: "பேமெண்ட் நேரடியா உங்க பேங்கிற்கு · 0% கமிஷன்",
            textOverlay: "💸 0% Commission · Direct UPI"
          },
          {
            time: "18–25s",
            visual: "Golden free trial highlight.",
            voiceover: "Unga boutique website ready-ah irukku. 7 days free trial-la ippove use panni paarunga!",
            voiceoverLocal: "14 நாட்கள் இலவச டிரையல்",
            textOverlay: "✨ 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "CTA tap.",
            voiceover: "Keezha irukura link-ah click pannunga, 60 seconds-la unga boutique website live aagidum!",
            voiceoverLocal: "60 நொடியில் உங்கள் புட்டிக் வெப்சைட் லைவ்!",
            textOverlay: "👉 Click 'Try Demo' Now!"
          }
        ]
      }
    ],

    kn: [
      {
        id: "kn-4a",
        type: "generic",
        title: "Script 4A: Generic (Karnataka Home Businesses & Online Sellers)",
        target: "Bangalore, Mysore, Hubli, Mangalore home entrepreneurs",
        tone: "Professional, direct, encouraging Kanglish",
        destination: "https://ownezzy.com/websites",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller busy with hundreds of WhatsApp pings asking 'Price estu?', 'Available idya?'.",
            voiceover: "Instagram nalli business maadthiraa? Innu daily 'Price please' antha DM nalli reply maadi bezaaraagidya?",
            voiceoverLocal: "ಇನ್‌ಸ್ಟಾಗ್ರಾಮ್‌ನಲ್ಲಿ ಬಿಸಿನೆಸ್ ಮಾಡ್ತಿದ್ದೀರಾ? ದಿನಾ 'Price please' ಅಂತ DM ಮಾಡಿ ಸಾಕಾಗಿದ್ಯಾ?",
            textOverlay: "❌ 'Price Please' DM-ge reply maadi bezaaraagidya?"
          },
          {
            time: "4–10s",
            visual: "Buyer stops replying after asking GPay QR code.",
            voiceover: "Customer GPay number kelthare, aadre payment maadadhe disappear aagthare. Heege nimma tumba orders miss aagthide!",
            voiceoverLocal: "ಕಸ್ಟಮರ್ ಪೇಮೆಂಟ್ ಮಾಡ್ದೆ ಮಾಯ ಆಗ್ತಿದ್ದಾರಾ?",
            textOverlay: "📉 Ghost aagora customers & Orders loss"
          },
          {
            time: "10–18s",
            visual: "Smooth ordering on Ownezzy store with phone UPI payment and instant WhatsApp confirmation.",
            voiceover: "Idhakkagi bandhide Ownezzy! Just 60 seconds nalli nimma swantha online store ready. Direct UPI payments, WhatsApp order alerts, matthe ZERO percent commission!",
            voiceoverLocal: "60 ಸೆಕೆಂಡಿನಲ್ಲಿ ನಿಮ್ಮದೇ ಆನ್‌ಲೈನ್ ಸ್ಟೋರ್! ನೇರ UPI & 0% ಕಮಿಷನ್",
            textOverlay: "🚀 60 Sec-nalli Nimma Website! | ⚡ Direct PhonePe / GPay | 💰 0% Commission"
          },
          {
            time: "18–25s",
            visual: "Display trial badge.",
            voiceover: "Yavudhe coding beda, credit card-u beda. 7 days 100% Free Trial eegale try maadi.",
            voiceoverLocal: "ಯಾವುದೇ ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಬೇಡ · 14 ದಿನ ಉಚಿತ ಟ್ರಯಲ್",
            textOverlay: "🎁 7-Day Free Trial · No Card Needed"
          },
          {
            time: "25–30s",
            visual: "Pointer to ad CTA.",
            voiceover: "Kelagiro link munde click maadi, ivatte nimma online store shuru maadi!",
            voiceoverLocal: "ಈಗಲೇ ಕೆಳಗಿನ ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ!",
            textOverlay: "👉 Click Link Below / Sign Up 🚀"
          }
        ]
      },
      {
        id: "kn-4b",
        type: "niche",
        niche: "crafts",
        title: "Script 4B: Niche-Specific (Handicrafts, Decor & Footwear)",
        target: "Karnataka artisans, resin creators, handmade footwear makers",
        tone: "Appreciative of arts, modern Kanglish",
        destination: "https://crafts.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Artisan packing handmade footwear, resin art, and wooden crafts.",
            voiceover: "Nimma handmade crafts, footwear athava home decor product-galannu Instagram nalli sale maadthiraa?",
            voiceoverLocal: "ಹ್ಯಾಂಡ್‌ಮೇಡ್ ಕ್ರಾಫ್ಟ್ಸ್ & ಪಾದರಕ್ಷೆಗಳ ವ್ಯಾಪಾರ ಮಾಡ್ತಿದ್ದೀರಾ?",
            textOverlay: "🏺 Handmade Crafts & Footwear Sellers"
          },
          {
            time: "4–10s",
            visual: "Showing craft store catalog: multi-angle photos, color pickers, and live price.",
            voiceover: "Ownezzy nalli nimma products-ge pre-built attractive store ide. Customer-galu photo nodi, size choose maadi, direct order maadbahudu!",
            voiceoverLocal: "ರೆಡಿಮೇಡ್ ವೆಬ್‌ಸೈಟ್ · ಕಸ್ಟಮರ್ ನೇರವಾಗಿ ಆರ್ಡರ್ ಮಾಡ್ತಾರೆ",
            textOverlay: "🎨 Ready Niche Store with 30+ Products"
          },
          {
            time: "10–18s",
            visual: "UPI payment directly to bank account.",
            voiceover: "Payment direct nimma bank-ge barutthe, matthe 0% commission!",
            voiceoverLocal: "ನೇರ ಬ್ಯಾಂಕ್ UPI · 0% ಕಮಿಷನ್",
            textOverlay: "💸 0% Commission · Direct UPI"
          },
          {
            time: "18–25s",
            visual: "Free trial screen.",
            voiceover: "7 days free trial ide, ondu rupayi kooda munche kodbekagilla!",
            voiceoverLocal: "14 ದಿನ ಉಚಿತವಾಗಿ ಟೆಸ್ಟ್ ಮಾಡಿ",
            textOverlay: "🌟 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "CTA tap.",
            voiceover: "Eegale kelagina link click maadi, nimma brand-annu launch maadi!",
            voiceoverLocal: "ಈಗಲೇ ಕೆಳಗಿನ ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ!",
            textOverlay: "👉 Click 'Try Demo' Now!"
          }
        ]
      }
    ],

    ml: [
      {
        id: "ml-5a",
        type: "generic",
        title: "Script 5A: Generic (Kerala Instagram Sellers & Homepreneurs)",
        target: "Kochi, Calicut, Trivandrum, Thrissur, Kannur boutique and online sellers",
        tone: "Polished, relatable, modern Manglish",
        destination: "https://ownezzy.com/websites",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Seller swiping through flooded Instagram DMs.",
            voiceover: "Instagram-il business cheyyunnavaraano? Ennum 'Price please'-num 'Details please'-num DM-il reply koduthu madutho?",
            voiceoverLocal: "ഇൻസ്റ്റാഗ്രാമിൽ ബിസിനസ്സ് ചെയ്യുന്നവരാണോ? എപ്പോഴും 'Price please'-ന് മറുപടി കൊടുത്ത് മടുത്തോ?",
            textOverlay: "❌ 'Price Please' DM-il reply cheythu madutho?"
          },
          {
            time: "4–10s",
            visual: "Customer asking GPay number and disappearing.",
            voiceover: "GPay number chothichittu payment cheyyaathe povaano kooduthal aalukalum? Oro divasavum ethrayo orders aanu ingane nashtappedunnath!",
            voiceoverLocal: "പേയ്മെന്റ് ചെയ്യാതെ പോകുന്ന കസ്റ്റമേഴ്സ് കാരണം ഓർഡറുകൾ നഷ്ടപ്പെടുന്നുണ്ടോ?",
            textOverlay: "📉 Payment cheyyaathe pokunna customers"
          },
          {
            time: "10–18s",
            visual: "Sleek mobile store with 1-click UPI and automated WhatsApp confirmation receipt.",
            voiceover: "Inithaanu Ownezzy! Verum 60 seconds-il ningalude swantham online store thudangaam. Direct UPI payments, WhatsApp order alerts, and ZERO percent commission!",
            voiceoverLocal: "വെറും 60 സെക്കൻഡിൽ സ്വന്തം ഓൺലൈൻ സ്റ്റോർ! 0% കമ്മീഷൻ!",
            textOverlay: "🚀 60 Sec-il Ningalude Website! | ⚡ Direct PhonePe / GPay | 💰 0% Commission"
          },
          {
            time: "18–25s",
            visual: "7-day trial badge.",
            voiceover: "Coding venda, credit card-um venda. 7 Days 100% Free Trial ippol thanne thudangoo.",
            voiceoverLocal: "ക്രെഡിറ്റ് കാർഡ് വേണ്ട · 14 ദിവസം സൗജന്യ ട്രയൽ",
            textOverlay: "🎁 7-Day Free Trial · No Card Needed"
          },
          {
            time: "25–30s",
            visual: "Pointer to CTA button.",
            voiceover: "Thazheyulla link click cheythu, ningalude online store innu thanne live aakkoo!",
            voiceoverLocal: "ഇപ്പോൾ തന്നെ താഴെയുള്ള ലിങ്കിൽ ക്ലിക്ക് ചെയ്യൂ!",
            textOverlay: "👉 Click Link Below / Sign Up 📲"
          }
        ]
      },
      {
        id: "ml-5b",
        type: "niche",
        niche: "blouses",
        title: "Script 5B: Niche-Specific (Kerala Boutiques, Sarees & Dhotis)",
        target: "Kerala bridal boutiques, saree designers, kasavu sellers",
        tone: "Elegant, entrepreneurial, Manglish",
        destination: "https://blouses.ownezzy.com",
        duration: "25–30s",
        scenes: [
          {
            time: "0–4s",
            visual: "Kasavu sarees, designer churidars, and bridal blouse embroidery.",
            voiceover: "Kerala saree, churidar, allel bridal boutique business cheyyunnavaraano ningal? Measurements-um designs-um WhatsApp-il vangi budhimuttunno?",
            voiceoverLocal: "ബുട്ടിക്, സാരി ബിസിനസ്സ് ചെയ്യുന്നവരാണോ?",
            textOverlay: "👗 Boutique & Saree Sellers in Kerala"
          },
          {
            time: "4–10s",
            visual: "Custom blouse & dress selector showing necklines and sizing options.",
            voiceover: "Ownezzy-il ningalude boutique-nu vendi ready-made store thanneyundu. Customer-ku design, size select cheythu direct order cheyyaam.",
            voiceoverLocal: "കസ്റ്റമേഴ്സിന് ഡിസൈനും സൈസും സെലക്ട് ചെയ്ത് ഈസിയായി ഓർഡർ ചെയ്യാം",
            textOverlay: "✨ Custom Size & Design Selector"
          },
          {
            time: "10–18s",
            visual: "UPI payment ping on phone with 0% cut.",
            voiceover: "Direct UPI payment ningalude bank account-il ethum. Ownezzy oru roopa polum commission edukilla!",
            voiceoverLocal: "നേരിട്ട് ബാങ്കിലേക്ക് പണം · 0% കമ്മീഷൻ",
            textOverlay: "💸 0% Commission · Direct UPI"
          },
          {
            time: "18–25s",
            visual: "Free trial card.",
            voiceover: "Ningalude boutique website ready aanu. 7 days free trial-il ippol thanne test cheythu nokkoo!",
            voiceoverLocal: "14 ദിവസം സൗജന്യമായി ഉപയോഗിക്കാം",
            textOverlay: "🌟 7-Day Free Trial Live"
          },
          {
            time: "25–30s",
            visual: "CTA tap.",
            voiceover: "Thazheyulla link click cheyyoo, 60 seconds-il ningalude boutique online aakkoo!",
            voiceoverLocal: "താഴെയുള്ള ലിങ്ക് ക്ലിക്ക് ചെയ്യൂ!",
            textOverlay: "👉 Click 'Try Demo' Now!"
          }
        ]
      }
    ]
  },

  targetingPresets: [
    {
      id: "south-india-boutiques",
      name: "South India Boutiques & Sarees",
      geos: "Tamil Nadu (Chennai, Coimbatore, Madurai, Tirupur), Karnataka (Bangalore, Mysore), AP/Telangana (Hyderabad, Vijayawada), Kerala (Kochi)",
      demographics: "Women, Age 22–45",
      interests: "Boutique, Saree, Embroidery, Kurti, Handmade jewelry, Facebook Page Admins, Instagram Business Profiles",
      placements: "Instagram Reels (90%), Stories (10%) - Mobile Only",
      recommendedBudget: "₹1,500 / day",
      landingPage: "https://blouses.ownezzy.com"
    },
    {
      id: "genz-phone-cases",
      name: "Gen-Z Custom Phone Cases & Skins",
      geos: "Pan-India Tier-1 & Tier-2 (Bangalore, Delhi, Mumbai, Pune, Hyderabad, Ahmedabad)",
      demographics: "All genders, Age 18–32",
      interests: "Custom Phone Cases, Smartphone accessories, Anime, Streetwear, Shopify, Meesho Sellers",
      placements: "Instagram Reels (95%) - Mobile Only",
      recommendedBudget: "₹1,000 / day",
      landingPage: "https://cases.ownezzy.com"
    },
    {
      id: "general-home-sellers",
      name: "Pan-India Home Businesses & Micro-Sellers",
      geos: "All Tier-2 & Tier-3 industrial and commercial hubs across India",
      demographics: "All genders, Age 20–48",
      interests: "Small Business Owner, Reseller, Handicrafts, Home decor, Zero commission ecommerce",
      placements: "Instagram Reels (80%), Stories (15%), Facebook Feeds (5%)",
      recommendedBudget: "₹2,000 / day",
      landingPage: "https://ownezzy.com/websites"
    }
  ],

  objections: [
    {
      objection: "I'm not technical. I don't know how to run a website.",
      response: "You don't need any technical knowledge. If you know how to post a photo on Instagram, you can manage Ownezzy from your phone in 30 seconds."
    },
    {
      objection: "How do I get my money?",
      response: "Customer payments go directly to your personal PhonePe, Google Pay, or Paytm account. Ownezzy takes 0% commission."
    },
    {
      objection: "What if I want my own .com or .in domain?",
      response: "You can connect your own domain (e.g. kavyaboutique.com) anytime from your admin panel with 1 click."
    },
    {
      objection: "What if I don't want to continue after 7 days?",
      response: "There is zero risk. You haven't entered any credit card, and you will never be charged automatically. If you don't love it, you pay nothing."
    },
    {
      objection: "Will my customers be comfortable ordering online?",
      response: "Yes! Indian shoppers love UPI. When they see PhonePe and Google Pay with instant WhatsApp receipts, they feel 10x safer than paying into a random chat QR code."
    }
  ],

  salesCadence: [
    {
      stage: "Minute 0",
      title: "Instant Automated WhatsApp Welcome",
      trigger: "Triggered immediately when merchant creates their subdomain in Step 3.",
      template: `Hi {{SellerName}}! 🎉 Congratulations! Your online store *{{StoreName}}.ownezzy.com* is now officially live!

Here is your private Admin Panel link to add your own products and link your UPI/GPay:
🔗 https://admin.ownezzy.com
Admin ID: {{AdminId}}
Temporary Password: {{TempPassword}}

Need help uploading your first 5 products or your logo? Reply *HELP* and our onboarding specialist will assist you free of charge!`
    },
    {
      stage: "Day 3",
      title: "The 'Link in Bio' Activation Prompt",
      trigger: "Sent 72 hours after trial signup to drive buyer traffic.",
      template: `Hi {{SellerName}}! Have you added your store link *{{StoreName}}.ownezzy.com* to your Instagram Bio yet?

Sellers who put their website in their bio get 4x more orders without answering DMs!
Watch this 30-second quick guide on how to add it: https://ownezzy.com/blog/why-every-business-seller-needs-an-online-website`
    },
    {
      stage: "Day 7",
      title: "Concierge Onboarding & UPI Check-in",
      trigger: "Sent on Day 7 to ensure store catalog and payment QR are active.",
      template: `Hi {{SellerName}}, checking in on *{{StoreName}}*! Have you linked your PhonePe / GPay QR code yet?

If you are busy running your shop, let us help! Send us 10 product photos and prices right here on WhatsApp; our team will upload them into your store for you today for free! 🎁`
    },
    {
      stage: "Day 12",
      title: "Trial-to-Paid Conversion Closing Offer",
      trigger: "Sent 48 hours before the 7-day trial concludes.",
      template: `Hi {{SellerName}}, your 7-day free trial on Ownezzy ends in 48 hours. Your store has had {{VisitsCount}} visits this week!

Keep your store live and accepting automated UPI orders for just ₹399/month on our yearly plan (or ₹499/mo).
Activate your plan in 1 click here: https://admin.ownezzy.com/billing`
    }
  ],

  actionChecklist: [
    {
      id: "act-1",
      priority: "critical",
      title: "Configure Meta Ads Pixel on Demo Subdomains",
      description: "Ensure the Meta Pixel with conversion events 'modal_open' and 'trial_continue_click' is loaded on blouses.ownezzy.com and cases.ownezzy.com.",
      completed: true
    },
    {
      id: "act-2",
      priority: "critical",
      title: "Deploy 10-Second Auto-Modal on Demo Store Traffic",
      description: "Visitors browsing niche demos for 10 seconds automatically receive the 'Get It For Free' 7-day trial offer popup.",
      completed: true
    },
    {
      id: "act-3",
      priority: "critical",
      title: "Record Multilingual Video Ads in Tamil & Hindi",
      description: "Produce vertical 9:16 reels for Script 1B (Aari Blouse) and Script 2A (Hindi Generic) with native voiceovers.",
      completed: false
    },
    {
      id: "act-4",
      priority: "critical",
      title: "Launch ₹10,000/Month Meta Ads Campaign",
      description: "Activate ₹333/day split across South India Blouses (₹140/day), Custom Phone Cases (₹93/day), and Google Search exact match (₹66/day).",
      completed: false
    },
    {
      id: "act-5",
      priority: "recommended",
      title: "Automate WhatsApp Welcome & Day 3 Nudge Sequence",
      description: "Connect WhatsApp Business API / webhook to send Minute 0 login details and Day 3 bio link tutorial.",
      completed: true
    },
    {
      id: "act-6",
      priority: "recommended",
      title: "Deploy Traffic Routing UTM Links on All Ad Sets",
      description: "Verify that all 11 ad sets have exact destination deep links to niche subdomains (/create/* and *.ownezzy.com).",
      completed: true
    },
    {
      id: "act-7",
      priority: "growth",
      title: "Surat & Jaipur Textile Merchant Outreach",
      description: "Direct outreach to saree and kurti manufacturer associations offering ready-made digital catalogs.",
      completed: false
    },
    {
      id: "act-8",
      priority: "growth",
      title: "Launch ₹1 Trial Landing Page Campaign",
      description: "A/B test the 1 Rupee introductory offer on high-intent search ads vs the 7-day free trial.",
      completed: false
    }
  ],

  whatsappAutoReplies: {
    mobileAppGuide: [
      {
        step: "1",
        title: "Open WhatsApp Business & Go to Business Tools",
        detail: "Open the WhatsApp Business app on your phone, tap the 3 vertical dots ⋮ (Android) or Settings ⚙️ (iOS) > 'Business tools'."
      },
      {
        step: "2",
        title: "Setup 'Greeting Message' (First-Response Interactive Menu)",
        detail: "Tap 'Greeting message', switch 'Send greeting message' to ON. In Recipients, select 'Everyone'. Tap 'Greeting message' to paste Template #1 below and tap Save."
      },
      {
        step: "3",
        title: "Setup 'Away Message' (After Hours & Instant Triage)",
        detail: "Tap 'Away message', toggle ON. Choose Schedule: 'Outside of business hours' or 'Always send'. Paste Template #6 (Human Support queue) and save."
      },
      {
        step: "4",
        title: "Configure 'Quick Replies' (/demo, /price, /launch, /support)",
        detail: "Tap 'Quick replies' > tap '+'. Set shortcut to '/demo', paste Template #2. Tap '+' again, set shortcut to '/price', paste Template #3. Whenever chatting with any customer, just type '/' to instantly send any full answer!"
      }
    ],
    cloudApiWebhookGuide: {
      status: "⚡ Server Webhook Live & Ready",
      endpoint: "https://admin.ownezzy.com/api/whatsapp/webhook",
      verificationMode: "GET challenge with WHATSAPP_VERIFY_TOKEN",
      inboundParser: "POST HMAC-SHA256 signature check & autoReply.getReplyForMessage()",
      supportedKeywords: "Numbers 1-5, 'demo', 'pricing', 'create', 'custom', 'support', 'blouse', 'case'",
      configFields: [
        { key: "WHATSAPP_TOKEN", label: "System User Permanent Access Token" },
        { key: "WHATSAPP_PHONE_NUMBER_ID", label: "Meta Business Phone Number ID" },
        { key: "WHATSAPP_VERIFY_TOKEN", label: "Custom Secret Token set in Meta App Webhook" },
        { key: "WHATSAPP_APP_SECRET", label: "Meta App Secret for HMAC-SHA256 Verification" }
      ]
    },
    scripts: [
      {
        id: "menu",
        category: "Greeting & Menu",
        name: "1. Main Interactive Greeting Menu (1st Inbound Message)",
        shortcut: "/start",
        trigger: "Any new inbound message / 'Hi' / 'Hello' / First interaction",
        text: `👋 *Welcome to Ownezzy!*\nThe 60-Second E-Commerce Engine for Shop Owners & Creators 🚀\n\nLaunch your own branded online store with:\n✅ Direct UPI payments (PhonePe / GPay) to your bank\n✅ 0% platform sales commission\n✅ Instant WhatsApp order notifications\n✅ 7-Day 100% Free Trial (No credit card needed)\n\n━━━━━━━━━━━━━━━━━━━\n👉 *Reply with a number to explore:*\n1️⃣ *Live Demo Stores* (Clothing, Cases, Footwear, etc.)\n2️⃣ *Pricing & Free Trial Details*\n3️⃣ *How to Launch Your Store in 60 Seconds*\n4️⃣ *Request a Custom Website for Your Niche*\n5️⃣ *Talk to Human Support / Specialist*\n━━━━━━━━━━━━━━━━━━━`
      },
      {
        id: "demos",
        category: "Demo Links",
        name: "2. 100+ Live Niche Demo Stores Directory",
        shortcut: "/demo",
        trigger: "Customer replies '1' or mentions 'demo', 'link', 'sample', 'example', 'preview'",
        text: `✨ *Explore Our 100+ Ready-Made Live Demo Stores:*\n\n👗 *Clothing & Boutiques:* https://fashion.ownezzy.com\n🥻 *Aari & Bridal Blouses:* https://blouses.ownezzy.com\n📱 *Custom Phone Cases:* https://cases.ownezzy.com\n👡 *Footwear & Juttis:* https://footwear.ownezzy.com\n💍 *Handmade Jewelry:* https://ownezzy.com/create/jewelry-website\n🪔 *Brassware & Urulis:* https://uruli.ownezzy.com\n🌱 *Plants & Nursery:* https://plants.ownezzy.com\n🎁 *Gift Hampers:* https://gifts.ownezzy.com\n🐾 *Pet Store:* https://pet.ownezzy.com\n🧁 *Bakery & Cakes:* https://ownezzy.com/create/bakery-cakes-website\n🛏️ *Cotton Bedsheets:* https://linens.ownezzy.com\n\n🌐 *Browse all 100+ stores:* https://ownezzy.com/websites\n\n👉 *Want this website for your shop?*\nStart your 7-day free trial now: https://ownezzy.com#plans`
      },
      {
        id: "pricing",
        category: "Pricing & Offer",
        name: "3. Transparent Pricing, 7-Day Trial & 0% Commission",
        shortcut: "/price",
        trigger: "Customer replies '2' or mentions 'price', 'cost', 'plan', 'charge', 'rate', 'fees'",
        text: `💰 *Ownezzy Transparent Pricing:*\n\n🎁 *7-Day 100% Free Trial*\n• Zero cost, no credit card required. Full dashboard access.\n\n🌟 *Monthly Plan: ₹399 / month*\n• Unlimited products, automated orders, direct UPI payments, WhatsApp alerts, SSL security, phone order bell alarm.\n\n💎 *Yearly Plan: ₹4,499 / year* (about ₹375 a month)\n\n💸 *0% Sales Commission!*\nEvery customer payment goes directly into your personal PhonePe, Google Pay, or bank account. We take 0% cut from your orders.\n\n👉 *Claim your 7-day free trial:* https://ownezzy.com#plans`
      },
      {
        id: "createStore",
        category: "Store Creation",
        name: "4. How to Launch Store in 60 Seconds Guide",
        shortcut: "/launch",
        trigger: "Customer replies '3' or mentions 'create', 'start', 'how to', 'setup', 'register', 'make'",
        text: `⚡ *How to Launch Your Website in 60 Seconds:*\n\n1️⃣ Tap here: https://ownezzy.com#plans\n2️⃣ Type your Store Name and WhatsApp Number.\n3️⃣ Pick your business template (Boutique, Cases, Plants, etc.).\n4️⃣ Your website goes live INSTANTLY with 30 sample products!\n\n📱 You get an instant WhatsApp message with your Admin ID and password to manage your products and link your UPI QR code.\n\nNeed help uploading photos? Reply *HELP* and our team will upload your first 10 products for free!`
      },
      {
        id: "customStore",
        category: "Custom Store",
        name: "5. Custom Website for Unique / Unlisted Niches",
        shortcut: "/custom",
        trigger: "Customer replies '4' or mentions 'custom', 'other niche', 'my category', 'different'",
        text: `🎨 *Request a Custom Website for Your Unique Business:*\n\nWe build specialized online stores with direct UPI checkout for ANY unique industry:\n• Tailoring & Bridal Embroidery\n• Homemade Chocolates, Cakes & Cloud Kitchens\n• Resin Art, Candle Making & Crafts\n• Industrial Tools & Wholesale B2B\n• Regional Spices & Gourmet Foods\n\n👉 *Reply to this message with:*\n1. Your Business Name\n2. What products you sell\n3. Your city/location\n\nOur design team will send you a tailored demo preview within 2 hours! 🚀`
      },
      {
        id: "support",
        category: "Human Escalation",
        name: "6. Human Specialist Support Queue & Away Message",
        shortcut: "/support",
        trigger: "Customer replies '5' or mentions 'support', 'human', 'agent', 'call', 'talk', 'help'",
        text: `👤 *You are being connected to Human Support!*\n\nOur Merchant Success team is available Monday to Saturday, 9:30 AM to 7:00 PM IST.\n\nPlease type your query or issue below (e.g. Domain linking, Payment setup, Catalog update):\n\nA support specialist will take over this chat shortly. You can also reach us at support@ownezzy.com.`
      },
      {
        id: "boutique",
        category: "Niche Reply",
        name: "7. Aari Blouses & Designer Boutique Specialists",
        shortcut: "/blouse",
        trigger: "Customer mentions 'blouse', 'saree', 'kurti', 'boutique', 'aari'",
        text: `👗 *Aari & Designer Blouse Studio by Ownezzy:*\n\nSay goodbye to taking blouse measurements and chest sizes on rough paper notebooks!\n\n✨ *Live Demo:* https://blouses.ownezzy.com\n• Interactive neck pattern selector (Round, U, Pot, Boat, Deep V)\n• Custom chest & sleeve measurement form\n• Direct UPI advance payment\n• 0% commission on every order\n\n👉 *Start your 7-day free trial:* https://ownezzy.com/create/clothing-website`
      },
      {
        id: "cases",
        category: "Niche Reply",
        name: "8. Custom Phone Cases & Mobile Covers",
        shortcut: "/case",
        trigger: "Customer mentions 'phone', 'case', 'skin', 'cover', 'mobile'",
        text: `📱 *Custom Phone Cases & Tech Skins Studio:*\n\nStop asking customers for their phone model and photo in DMs!\n\n✨ *Live Demo:* https://cases.ownezzy.com\n• Interactive 3D phone model selector (iPhone, Samsung, OnePlus)\n• Customer photo & sticker upload box\n• Instant UPI checkout with WhatsApp alerts\n\n👉 *Launch your phone case store:* https://ownezzy.com/create/phone-cases-website`
      }
    ],
    quickReplyShortcuts: [
      { shortcut: "/start", purpose: "Send Welcome Greeting & 5-Option Interactive Menu", trigger: "Inbound Greeting" },
      { shortcut: "/demo", purpose: "Share links to all 100+ niche live demo websites", trigger: "Customer asks for samples" },
      { shortcut: "/price", purpose: "Explain ₹399/mo, 7-day free trial & 0% commission", trigger: "Pricing questions" },
      { shortcut: "/launch", purpose: "60-second store creation link & step-by-step instructions", trigger: "Customer wants to register" },
      { shortcut: "/custom", purpose: "Collect business name, product line & city for custom niche store", trigger: "Unlisted niche enquiry" },
      { shortcut: "/support", purpose: "Escalate conversation to merchant success agent", trigger: "Complex technical doubt" },
      { shortcut: "/blouse", purpose: "Direct demo & measurement form link for tailoring / boutiques", trigger: "Aari / saree seller" },
      { shortcut: "/case", purpose: "Direct demo & photo upload link for phone case shops", trigger: "Mobile cover seller" }
    ]
  }
};
